module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "brown lighten-2",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.mealNames[_vm.index]) + ", " + _vm._s(_vm.displayDate))])], 1), _vm._v(" "), _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": _vm.addMealElement
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._l((_vm.mealElements), function(mealElement, index) {
    return [_c('v-list-tile', {
      key: mealElement.id,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [(mealElement.food_pict) ? _c('v-btn', {
      attrs: {
        "icon": "",
        "large": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.mealElementToZoomIn = mealElement;
          _vm.zoomImage = true
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.pictPath(mealElement.food_pict)
      }
    })]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(mealElement.food_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.mealElementQuantityDescription(mealElement)))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.editMealElement(mealElement)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.mealElementToDelete = _vm.clone(mealElement);
          _vm.deleteDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.mealElements.length) ? _c('v-divider', {
      key: mealElement.id + '-'
    }) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.mealElements.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "80px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: (_vm.zoomImage),
      callback: function($$v) {
        _vm.zoomImage = $$v
      },
      expression: "zoomImage"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.pictPath(_vm.mealElementToZoomIn.food_pict)
    }
  })]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.zoomImage = false
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirmer")]), _vm._v(" "), _c('v-card-text', [_vm._v("Supprimer " + _vm._s(_vm.mealElementToDelete.food_name) + " ?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.deleteMealElement()
      }
    }
  }, [_vm._v("Supprimer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600"
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('v-form', [_c('v-card', [(_vm.create) ? _c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Nouvel aliment")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [(!_vm.choosenFood) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Aliment (taper une partie du nom)",
      "loading": _vm.foodSearchLoading,
      "cache-items": "",
      "item-text": "shrt_desc",
      "required": "",
      "items": _vm.foodItems,
      "search-input": _vm.foodSearchInput,
      "return-object": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.foodSearchInput = $event
      }
    },
    model: {
      value: (_vm.choosenFood),
      callback: function($$v) {
        _vm.choosenFood = $$v
      },
      expression: "choosenFood"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.choosenFood) ? _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.choosenFood.shrt_desc))])]) : _vm._e(), _vm._v(" "), (_vm.choosenFood) ? _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "ripple": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.changeFood()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.choosenFoodPortions && (_vm.choosenFoodPortion || _vm.choosenFoodPortions.length === 1)) ? _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.pictPath(_vm.choosenFoodPortion.pict),
      "height": "150"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.choosenFoodPortions && (_vm.choosenFoodPortion || _vm.choosenFoodPortions.length === 1)) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.choosenFoodPortion.longuest_desc))])]) : _vm._e(), _vm._v(" "), (_vm.choosenFoodPortions && (_vm.choosenFoodPortion || _vm.choosenFoodPortions.length === 1)) ? _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [(_vm.choosenFoodPortions.length > 1) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "ripple": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeFoodPortion($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v("edit")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.choosenFoodPortions && !_vm.choosenFoodPortion && _vm.choosenFoodPortions.length > 1) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.choosenFoodPortions), function(foodPortion) {
    return _c('div', [_c('a', {
      on: {
        "click": function($event) {
          _vm.chooseFoodPortion(foodPortion)
        }
      }
    }, [_c('img', {
      staticClass: "portionImg",
      attrs: {
        "src": _vm.pictPath(foodPortion.pict),
        "height": "110"
      }
    })])])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.choosenFoodPortions && _vm.choosenFoodPortion) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "tick-labels": _vm.tickLabels,
      "ttthumb-label": "",
      "always-dirty": "",
      "max": 5,
      "min": 0.25,
      "step": "0.25",
      "ticks": "always",
      "tick-size": "1"
    },
    on: {
      "change": function($event) {
        _vm.$v.choosenWeight.$touch();
        _vm.onSliderChange($event)
      }
    },
    model: {
      value: (_vm.choosenFoodPortionCount),
      callback: function($$v) {
        _vm.choosenFoodPortionCount = $$v
      },
      expression: "choosenFoodPortionCount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.choosenFood) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Poids (g)",
      "error-messages": _vm.choosenWeightErrors,
      "blur": "$v.choosenWeight.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.choosenWeight.$touch();
        _vm.onWeightChangeDebounced(_vm.choosenWeight)
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debouncedCreateOrUpdate($event)
      }
    },
    model: {
      value: (_vm.choosenWeight),
      callback: function($$v) {
        _vm.choosenWeight = $$v
      },
      expression: "choosenWeight"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": "",
      "disabled": !_vm.formValid
    },
    nativeOn: {
      "click": function($event) {
        _vm.debouncedCreateOrUpdate()
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7431308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/meals/UserMealElements.vue
// module id = 1212
// module chunks = 1